import { IArticleResponse } from "../../../model/base/response/article-response";

export type CustomPageState = {
    detail: IArticleResponse | undefined;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setDetail = 'setDetail',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const CustomPageReducer = (state: CustomPageState, action: any): CustomPageState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDetail:
            return {
                ...state,
                detail: payload,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
                error: null,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
